import Icon from '../components/Icon.vue'

Icon.register({
  exclamation: {
    width: 192,
    height: 512,
    paths: [
      {
        d: 'M176 432c0 44.1-35.9 80-80 80s-80-35.9-80-80 35.9-80 80-80 80 35.9 80 80zM25.3 25.2c-0.7-13.7 10.2-25.2 24-25.2h93.5c13.7 0 24.7 11.5 24 25.2l-13.6 272c-0.6 12.8-11.2 22.8-24 22.8h-66.3c-12.8 0-23.3-10-24-22.8z'
      }
    ]
  }
})
